export default "__VITE_ASSET__DT4Ou1OD__"